/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SmartProblemDetails,
} from '../models/index';
import {
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

/**
 * 
 */
export class SettingsApi extends runtime.BaseAPI {

    /**
     */
    async settingsShouldPersistAnyUserActionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Settings/ShouldPersistAnyUserActions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async settingsShouldPersistAnyUserActionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.settingsShouldPersistAnyUserActionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async settingsUploadNewTermsOfUsePostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://852e32be-14b4-4154-884d-b9b5f479493f/access_as_user"]);
        }

        const response = await this.request({
            path: `/api/Settings/UploadNewTermsOfUse`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async settingsUploadNewTermsOfUsePost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.settingsUploadNewTermsOfUsePostRaw(initOverrides);
        return await response.value();
    }

}
